import { Link } from 'react-router-dom';

// datatype for custom button props declared here
interface IAcademiaLinkButton {
  title?: string;
  href: string;
  children: React.ReactNode;
  variant?:
    | 'primary'
    | 'premium'
    | 'danger'
    | 'success'
    | 'warning'
    | 'info'
    | 'social';
  customWidth?: number;
  afterBgColorClass?: string;
  fullWidth?: boolean;
  inverted?: boolean;
}

const AcademiaLinkButton = ({
  href,
  variant = 'primary',
  children,
  customWidth,
  afterBgColorClass,
  fullWidth,
  inverted,
}: IAcademiaLinkButton) => {
  // rendering custom link button component here
  return (
    <Link
      to={href}
      style={customWidth ? { width: `${customWidth}px` } : {}}
      className={`flex items-center justify-center gap-2 relative border-2 rounded-md px-8 py-3 active:scale-95 duration-300 after:absolute after:h-full after:w-0 after:top-0 after:left-0 hover:after:w-full after:origin-left after:duration-300 text-lg overflow-hidden ${
        fullWidth && 'w-full'
      } ${
        afterBgColorClass
          ? afterBgColorClass
          : inverted
          ? variant === 'primary'
            ? 'after:bg-legal-dark-blue'
            : variant === 'danger'
            ? 'after:bg-base-red'
            : variant === 'success'
            ? 'after:bg-base-dark-green'
            : variant === 'info'
            ? 'after:bg-base-cyan'
            : 'after:bg-base-orange'
          : 'after:bg-base-white'
      } ${
        inverted
          ? variant === 'primary'
            ? 'border-legal-dark-blue bg-base-white text-legal-dark-blue hover:text-base-white'
            : variant === 'danger'
            ? 'border-base-red bg-base-white text-base-red hover:text-base-white'
            : variant === 'success'
            ? 'border-base-dark-green bg-base-white text-base-dark-green hover:text-base-white'
            : variant === 'info'
            ? 'border-base-cyan bg-base-white text-base-cyan hover:text-base-white'
            : 'border-base-orange bg-base-white text-base-orange hover:text-base-white'
          : variant === 'primary'
          ? 'border-legal-dark-blue bg-legal-dark-blue text-base-white hover:text-legal-dark-blue'
          : variant === 'premium'
          ? 'border-legal-dark-blue bg-legal-dark-blue text-legal-brown disabled:hover:text-legal-brown hover:text-legal-dark-blue'
          : variant === 'danger'
          ? 'border-base-red bg-base-red text-base-white hover:text-base-red'
          : variant === 'success'
          ? 'border-base-dark-green bg-base-dark-green text-base-white hover:text-base-dark-green'
          : variant === 'info'
          ? 'border-base-cyan bg-base-cyan text-base-white hover:text-base-cyan'
          : 'border-base-orange bg-base-orange text-base-white hover:text-base-orange'
      }`}
    >
      <span className='relative flex items-center justify-center gap-2 z-10 capitalize'>
        {children}
      </span>
    </Link>
  );
};

export default AcademiaLinkButton;
